import { Navigate, useSearchParams } from 'react-router-dom';

/** Maps `/csa+/details-tabs?projectId=...` to `/csa+/project-details/:projectId` (CSA+ sidebar layout). */
const CSADetailsTabsRedirect = () => {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId')?.trim();
  if (!projectId) {
    return <Navigate to="/csa+/all-projects" replace />;
  }
  return <Navigate to={`/csa+/project-details/${encodeURIComponent(projectId)}`} replace />;
};

export default CSADetailsTabsRedirect;
